import { FunctionComponent } from 'react';
import SolutionWrapper from './solution.style';
import { SOLUTION_LABEL } from '@shared/values';
import SolutionProducts from '@component/SolutionProducts';
import SolutionAdvantage from '@component/SolutionAdvantage';
import SolutionProcess from '@component/SolutionProcess';
import QuestionAction from '@component/QuestionAction';
import HeadMetaTag from '@component/HeadMetaTags';
import { MainLayout } from '@component/LayoutContainer';

const Solution: FunctionComponent = () => {
  return (
    <MainLayout>
      <SolutionWrapper className="page-layout">
        <HeadMetaTag />
        <h1 className="page-title mobile">{SOLUTION_LABEL} 소개</h1>
        <div className="solution-products-wrapper">
          <SolutionProducts />
        </div>
        <div className="solution-advantage-wrapper">
          <SolutionAdvantage />
        </div>
        <div className="solution-process-wrapper">
          <SolutionProcess />
        </div>
        <QuestionAction />
      </SolutionWrapper>
    </MainLayout>
  );
};

export default Solution;
